import { configureStore } from '@reduxjs/toolkit';
import propertyReducer from '../layouts/property/propertySlice';
import configurationReducer from '../layouts/configurations/configurationSlice';
import serviceReducer from '../layouts/services/servicesSlice';
import cmsReducer from '../layouts/cms/cmsSlice';
import dashboardReducer from '../layouts/home/DashboardSlice';
import analyticsReducer from '../layouts/analytics/AnalyticsSlice';
import loaderReducer from '../utils/loaderSlice';

export default configureStore({
  reducer: {
    property: propertyReducer,
    configuration: configurationReducer,
    service: serviceReducer,
    cms: cmsReducer,
    dashboard: dashboardReducer,
    analytics: analyticsReducer,
    loader: loaderReducer,
  },
});
